import './AdditionalServices.css';

const AdditionalServices = () => {
  return (
    <section className='additional-services-container'>
      <h1 className='additional-services-title'>Servicios Adicionales</h1>
      <h2 className='additional-services-subtitle'>
        Además de nuestros servicios de Integración de CRM e Inteligencia Artificial, ofrecemos una variedad de servicios adicionales para ayudarte a maximizar tu negocio.
      </h2>
      <div className='additional-services-wrap'>
        <div className='additional-services-spacing'>
          <div>
            <h3>Desarrollo de CRM</h3>
            <p>Desarrollamos un CRM personalizado para tu negocio.</p>
          </div>
          <div>
            <h3>Telefonía</h3>
            <p>Ofrecemos soluciones para Call Center, telefonía IP a precios competitivos.</p>
          </div>
          <div>
            <h3>Blaster</h3>
            <p>Llamadas con audio personalizado para campañas de ventas/cobranza/marketing.</p>
          </div>
          <div>
            <h3>SMS</h3>
            <p>Envió de SMS normal y tipo flash a precios competitivos.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdditionalServices;
